var map = {
	"./angle-double-left.svg": [
		7812,
		76
	],
	"./angle-double-right.svg": [
		40370,
		40370
	],
	"./angle-left.svg": [
		78550,
		78550
	],
	"./angle-right.svg": [
		54408,
		54408
	],
	"./bone.svg": [
		3478,
		3478
	],
	"./brain-solid.svg": [
		21316,
		21316
	],
	"./brain.svg": [
		28614,
		28614
	],
	"./droplet-solid.svg": [
		32942,
		32942
	],
	"./ear-solid.svg": [
		52881,
		52881
	],
	"./eye.svg": [
		47120,
		47120
	],
	"./hand-solid.svg": [
		8682,
		8682
	],
	"./heart.svg": [
		63135,
		63135
	],
	"./kidneys-solid.svg": [
		20351,
		20351
	],
	"./lungs.svg": [
		77832,
		77832
	],
	"./stomach-solid.svg": [
		90441,
		90441
	],
	"./tooth.svg": [
		52997,
		52997
	],
	"./venus-mars.svg": [
		90571,
		90571
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35367;
module.exports = webpackAsyncContext;